
const FLOPPY = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█░▐███TIM███▌░█
█░▐MONKEY2██▌░█
█░▐███1994██▌░█
█░░░░░░░░░░░░░█
█░▄▄▄▄▄▄▄▄░░░░█
█░█░░░░░░█░░░░█
█░█░░░░░░█░░░░█
▀▄█▄▄▄▄▄▄█▄▄▄▄█`;

const ENVELOPE = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█▄▄░░░░░░░░░░░░▄▄█
█░░▀▀▄▄░░░░▄▄▀▀░░█
█░░░░░░▀▄▄▀░░░░░░█
█░░░░░░░░░░░░░░░░█
▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀`;

// A Game Boy cartridge, for the buffer that opens with an emulator.
const CARTRIDGE = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█▀▀▀▀▀▀▀▀▀▀▀▀▀█
█░▄▄▄▄▄▄▄▄▄▄▄░█
█░▐█TETRIS██▌░█
█░▐███1989██▌░█
█░▀▀▀▀▀▀▀▀▀▀▀░█
█░░░░░░░░░░░░░█
█░░░░░░░░░░░░▄▀
▀▀▀▀▀▀▀▀▀▀▀▀▀▀`;

export const WALLPAPERS = {
  "README.txt": FLOPPY,
  "projects.html": CARTRIDGE,
  "contact.html": ENVELOPE,
};
